<!-- body wrapper  -->
<div class="body-wrapper">

    <!-- ==========page banner ========== -->
    <div class="page-ban">
        <div class="page-ban-inner">
            <div class="container">
                <div class="page-content">
                    <h2 class="page-title">
                        About Us
                    </h2>
                    <div class="page-url">
                        <a routerLink="/" class="old-page">Home </a> /
                        <p>About</p>
                    </div>

                </div>
            </div>
        </div>
    </div>
    <!-- ==========page banner end ====== -->

    <!-- ===============about section ============ -->
    <section>
        <!-- about  -->
        <div class="about cpy-8 ">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row align-items-center">
                    <div class="col-lg-5 col-md-5 col-sm-12 col-12 pb-4">
                        <div class="about-img mts-5">
                            <img src="assets/img/about/5.png" alt="">
                        </div>
                    </div>
                    <div class="col-lg-7 col-md-7 col-sm-12 col-12 mb-4">
                        <div class="about-content">
                            <div class="sec-head mb-3">
                                <h4>ABOUT US</h4>
                                <h2 class="inside-head">Company Profile</h2>
                            </div>

                            <div class="about-content-inner mb-2">
                                <p class="pb-0 mb-3">We introduce ourselves as one of the leading manufacturers of
                                    Textile Machines for
                                    Weaving Preparatory, Indigo Dyeing Machinery, Processing, Inspection and Packing.
                                    Established in the July 2010 with the name of <span
                                        class="theme-color fw-bold">Prism Textile Machinery</span>. To design and
                                    develop latest technological machines for High Speed Direct Warping Machine, Multi
                                    Cylinder Sizing Machine, Indigo Dyeing with Slasher and Rope Technology, etc. with
                                    good engineering practice and international quality standards - backed with renowned
                                    after sales and services. In last few years of our existence. We have carved a niche
                                    par excellence in the market through consistently providing world class products and
                                    services. We have been striving to offer our customers, hi-tech machineries and
                                    latest equipments that assist to enhance the production and quality both in buyers
                                    manufacturing facility, thereby reducing the input cost of our valued clients.</p>

                                <p class="pb-0 mb-3">Initially <span class="theme-color fw-bold">Venus Techno Vision
                                        Pvt. Ltd</span>, was our venture to design and develop textile
                                    machinery in India, introduced first time Indian Machines for High Speed Direct
                                    Warping Machine, Indigo Dying and Sizing Plant and Multi cylinder sizing machines
                                    having tie up for manufacturing with one of Indian textile machinery manufacturing
                                    company, Installed no. of machines with 18 nos. Indigo complete plant within a
                                    period of 8 Years.</p>

                            </div>

                        </div>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mt-3 mb-3">
                        <div class="about-content-inner mb-2">
                            <p class="pb-0 mb-3">After that, we started our own manufacturing unit in July, 2010 with
                                the name changed
                                from <span class="theme-color fw-bold">Venus Techno Vision Pvt. Ltd</span>. To <span
                                    class="theme-color fw-bold">"Prism Textile
                                    Machinery"</span> It is committed to
                                excel for providing entire range of Textile Machineries as well as to provide
                                effective & prompt after sales services. The company has got cutting edge
                                innovation, facilities and management with working constantly having a motto of
                                <span class="theme-color fw-bold">"total customer satisfaction".</span>
                            </p>

                            <p class="pb-0 mb-0">We, at <span class="theme-color fw-bold">Prism Textile
                                    Machinery</span>, always keep in
                                the mind total customer satisfaction
                                while designing, developing & manufacturing any Textile Machine. Our team of
                                engineers also includes Textile engineers who consult us for designing of every
                                product for quality & performance to receive reliable & safe results. Since our
                                inception, we have registered a steep growth in our business and have earned the
                                recognition as one of the most efficient and reliable Textile Machinery manufacturer
                                of India.</p>
                        </div>
                    </div>

                    <div class="sec-head mb-3">
                        <h5 class="inside-head fw-bold fs-4">We can full fill our commitments as we have...</h5>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                        <p>
                            <i class="icofont-check-circled theme-color fs-5"></i>
                            Highly Technical qualified and experienced directors.
                        </p>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                        <p>
                            <i class="icofont-check-circled theme-color fs-5"></i>
                            Skilled and experienced team of Sales & Marketing, Design & Development, quality control and
                            production.
                        </p>
                    </div>
                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-3">
                        <p>
                            <i class="icofont-check-circled theme-color fs-5"></i>
                            We have three full fledged facilities in the heart of industrial zone of Gujarat - India at
                            Vatva G.I.D.C.
                        </p>
                    </div>

                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-4 signature">
                        <a routerLink="/contact-us" class="custom-btn">Get In Touch</a>
                    </div>

                </div>
                <!-- row end  -->
            </div>
            <!-- container  -->
        </div>
        <!-- about end  -->
    </section>
    <!-- ============about section end ========= -->

    <div class="work-history companies-new">
        <div class="container">
            <div class="box-shadow-new">
                <div class="history-bg-new">
                    <div class="sec-head">
                        <h2 class="">our group of companies</h2>
                    </div>
                </div>
                <div class="history-bg our-group-companies">
                    <div class="brand-item">
                        <div class="brand">
                            <a href="https://www.prismtextilemachinery.com/" target="_blank">
                                <img src="assets/img/group-companies/prism-textile.png" alt="Prism Textile"
                                    class="img-fluid brand-img">
                            </a>
                        </div>
                    </div>
                    <div class="brand-item">
                        <div class="brand">
                            <a href="https://www.prismpharmamachinery.com/" target="_blank">
                                <img src="assets/img/group-companies/prism-pharma.png" alt="Prism Pharma"
                                    class="img-fluid brand-img">
                            </a>
                        </div>
                    </div>
                    <div class="brand-item">
                        <div class="brand">
                            <a href="https://www.niharindustries.com/" target="_blank">
                                <img src="assets/img/group-companies/nihar-industries.png" alt="Nihar Industries"
                                    class="img-fluid brand-img">
                            </a>
                        </div>
                    </div>
                    <div class="brand-item">
                        <div class="brand">
                            <a href="javascript:void(0)">
                                <img src="assets/img/group-companies/fine-boring.png" alt="Fine Boring"
                                    class="img-fluid brand-img">
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <section class="our-story-section">
        <!-- ========faq sec========== -->
        <div class="story-sec cpy-8">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-8 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h2 class="mb-2 text-white">The Story Behind Us</h2>
                                <p class="text-white">
                                    Apart from making machines, We weave trust and relations through our service!
                                </p>
                                <p class="text-white">
                                    One Stop Solution for weaving preparatory and denim manufacturing all machines
                                    including both technologies Rope Dyeing & Slasher Dyeing except looms.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="mt-5">
                    <!-- row end  -->
                    <!-- row  -->
                    <div class="row">
                        <div class="col-lg-6 pb-0 align-self-center">
                            <img src="assets/img/faq/2.png" class="img-fluid p-2 rounded bg-theme-light w-100"
                                alt="story-image">
                        </div>

                        <div class="col-lg-6 pb-0 align-self-center">
                            <div class="about-content-inner mb-2">
                                <p class="pb-0 mb-3 text-white-75">
                                    We introduce ourselves as one of the most leading and emerging textile machines
                                    manufacturing unit as Prism Textile Machinery. Established in
                                    <span class="fw-semibold text-white">July 2010.</span>
                                </p>

                                <div class="row">
                                    <div class="col-lg-12 col-md-12 col-sm-12 col-12 mb-0">
                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>
                                            <span class="fw-semibold text-white">900+ machines</span> manufactured and
                                            installed successfully within a period of <span
                                                class="fw-semibold text-white">6 years</span>
                                        </p>

                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>
                                            <span class="fw-semibold text-white">90% Reputed</span> clients repeated
                                            their orders
                                        </p>

                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>Customized and Tailor made
                                            solutions
                                        </p>

                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>Headed by a Director who is
                                            Textile Engineer having <span class="fw-semibold text-white">43 years</span>
                                            of total field
                                            experience including <span class="fw-semibold text-white">22 years</span> in
                                            fabric manufacturing and <span class="fw-semibold text-white">21
                                                years</span>
                                            in textile machineries manufacturing
                                        </p>

                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>Highly qualified and
                                            experienced senior staff members for administration,
                                            designing, production, quality, sales & marketing, erection, after sales &
                                            services etc..
                                        </p>

                                        <p class="text-white-75 mb-3">
                                            <i class="icofont-check-circled fs-6 me-2"></i>All manufacturing facilities
                                            in house with <span class="fw-semibold text-white">M.S. & S.S</span>.
                                            fabrication shop and
                                            engineering machine shop.
                                        </p>

                                        <p class="text-white-75 mb-0">
                                            <i class="icofont-check-circled fs-6 me-2"></i>Four Full fledge
                                            manufacturing facilities in the heart of industrial zone at
                                            <span class="fw-semibold text-white">Vatva GIDC, Gujarat, India</span>.
                                        </p>
                                    </div>
                                </div>

                            </div>
                        </div>

                    </div>
                    <!-- row end  -->
                </div>
                <!--  -->
            </div>
            <!-- container end  -->
        </div>
        <!-- =========== faq end ======== -->
    </section>

    <!-- ===================faq section =========== -->
    <section>
        <!-- ========faq sec========== -->
        <div class="faq-sec project cpy-8">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-8 col-md-8 col-sm-10">
                            <div class="sec-head">
                                <h4 class="mb-0">Our Vision & Mission</h4>
                                <h2 class="my-2">Innovating Textile Machinery, Empowering Excellence.</h2>
                                <p>We are committed to designing and manufacturing high-performance textile machinery
                                    that enhances productivity, ensures quality, and promotes eco-friendly practices,
                                    helping our clients achieve excellence in denim fabric production.</p>
                            </div>
                        </div>
                    </div>
                </div>
                <!--  -->
                <div class="mt-5">
                    <!-- row end  -->
                    <!-- row  -->
                    <div class="row">
                        <div class="col-lg-6 pb-0 align-self-center">
                            <div class="faq-main">
                                <div class="faq-content">
                                    <div class="faq-que">
                                        <button>Our Vission</button> <i class="icofont-minus"></i>
                                    </div>
                                    <div class="faq-ans">
                                        <p>To attain a market leadership by manufacturing machines comparable to German
                                            standards and to be globally competitive with continuous innovation in
                                            technology by Indian brains.</p>
                                    </div>
                                </div>
                                <div class="faq-content">
                                    <div class="faq-que">
                                        <button>Our Mission</button> <i class="icofont-plus"></i>
                                    </div>
                                    <div class="faq-ans">
                                        <p>Our mission is to combine technology, well structured facilities, strong team
                                            & managerial skills with rich experience which ensures 'Total Customer
                                            Satisfaction'</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="col-lg-6 pb-0 align-self-center">
                            <div class="product-slider">
                                <div class="swiper productSlider">
                                    <div class="swiper-wrapper">
                                        <div class="swiper-slide">
                                            <div class="slider-item-img">
                                                <img src="assets/img/faq/1.png" alt="Image not found">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="slider-item-img">
                                                <img src="assets/img/faq/2.png" alt="Image not found">
                                            </div>
                                        </div>
                                        <div class="swiper-slide">
                                            <div class="slider-item-img">
                                                <img src="assets/img/faq/3.png" alt="Image not found">
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="faq-slider">
                                    <div class="swiper-button-next arrow-btn"></div>
                                    <div class="swiper-button-prev arrow-btn"></div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- row end  -->
                </div>
                <!--  -->
            </div>
            <!-- container end  -->
        </div>
        <!-- =========== faq end ======== -->
    </section>
    <!-- ===================faq section end =========== -->

    <!-- ================video section ============= -->
    <div class="work-history project">
        <div class="container">
            <div class="history-bg">
                <div class="row justify-content-center">
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/18.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>43+</h2>
                                    <p>Years Of Experience</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/19.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>900+ </h2>
                                    <p>Machines Installed</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/19.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>4 </h2>
                                    <p>Manufacturing Units</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-3 col-sm-6 col-6">
                        <div class="history-card">
                            <img src="assets/img/icon/20.png" alt="">
                            <div class="history-content">
                                <div class="content-inner">
                                    <h2>90%</h2>
                                    <p>Repeat Orders</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="video-sec">

        <img src="assets/img/video/1.png" alt="Image not found">

        <div class="video-play">
            <a (click)="videoOverlay.openVideo('www.youtube.com/embed/NUooTKtmgz8')"
                class="play-video video-btn cursor-pointer"><span class="icofont-ui-play play-icon-larg"></span></a>
        </div>
    </div>
    <!-- ================video section end ============= -->
    <!-- ============team ======== -->
    <section>
        <div class="team project cpy-8">
            <!-- container  -->
            <div class="container">
                <!-- row  -->
                <div class="row">
                    <div class="sec-title">
                        <div class="col-lg-12 col-md-12 col-sm-12">
                            <div class="sec-head">
                                <h4 class="mb-0">Our STRENGTHS</h4>
                                <h2 class="my-2">Top Management Team</h2>
                                <p>
                                    We have a team of internationally acclaimed quality control team, who inspect the
                                    entire manufacturing process & test finished products to ensure global quality. All
                                    our machines are designed & manufactured with the close co-ordination with our
                                    customers who are end user to avoid any defect. We possess five full fledged
                                    facilities with advanced in-house technological set-up at India's heart of
                                    industrial area in G.I.D.C. Vatva, Gujarat, Ahmedabad India.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- row end  -->
                <div class="mt-5">
                    <div class="swiper team-slider">
                        <div class="swiper-wrapper">
                            <div class="swiper-slide mb-4" *ngFor="let team of teamListArr; let t = index;">
                                <div class="team-card">
                                    <img [src]="team?.image" alt="" class="team-img">
                                    <div class="team-member-info">
                                        <a [routerLink]="['/team-details', team?.id]">{{team?.name}}</a>
                                        <p>{{team?.occupation}}</p>
                                    </div>

                                    <div class="user-social">
                                        <ul class="user-social-ul">
                                            <li>
                                                <a [href]="team?.facebookLink" target="_blank"
                                                    class="social-link cursor-pointer">
                                                    <i class="icofont-facebook"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a [href]="team?.linkedinLink" target="_blank"
                                                    class="social-link cursor-pointer">
                                                    <i class="icofont-linkedin"></i>
                                                </a>
                                            </li>
                                            <li>
                                                <a [href]="team?.instaLink" target="_blank"
                                                    class="social-link cursor-pointer">
                                                    <i class="icofont-instagram"></i>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <!-- container end  -->
        </div>
    </section>
    <!-- ============team end  ======== -->
    <app-video-overlay #videoOverlay></app-video-overlay>
</div>
<!-- body wrapper end -->